import { CreatedAt, UpdatedAt } from "@_types/shared";
import { z } from "zod";

export const CourseSchema = z.object({
  uuid: z.string().uuid(),
  name: z.string(),
  userUuid: z.string(),
  productUuid: z.string(),
  coverPicture: z.string(),
  contactName: z.string(),
  contactEmail: z.string(),
  contactPhone: z.string(),
  format: z.string(),
  createdAt: CreatedAt,
  updatedAt: UpdatedAt,
});
